module.exports = __webpack_public_path__ + "img/chat-send-button-disabled.ede50772.svg";